<template>
    <section class="no-notification no_notification_container">
        <div class="container">
            <div class="no-notification-icon no_data_found">
                <img src="@/assets/images/no-record-img.svg" alt="">
            </div>
            <div class="notification-msg-detail">
                <h3>{{ $t('no-data-found','No Records found')}}!</h3>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "NoDataFound",
}
</script>

